import type { RouterConfig } from '@nuxt/schema'
import { customScrollBehavior } from '#imports'

export default <RouterConfig>{
  scrollBehavior(to, from) {
    return customScrollBehavior(to, from)
  },
}
